<template>
  <div class="ckWrap">
    <div class="menuLeftck">
        <h2 class="ckTitles">仓库列表</h2>
        <div class="menuLeftWrapck">
          <span class="storeNameck" v-for="item in storgaeListData" v-bind:key="item.id" @click="to">
            <span class="storeName">{{ item.name}}</span>
            <!-- <span class="storeName">{{ item.name.split('-')[0].replace('【', '').replace('】', '') }}</span> -->
            <span class="price">¥{{ item.deliver_price }}元</span>
            <!-- <div v-if="item.name.indexOf('100') != -1 || item.name.indexOf('百分比') != -1" class="subtitle" data-v-7ed503b6="">100%派送</div> -->
          </span>
        </div>
    </div>
  </div>
</template>

<script>
// import { seachLog } from 'network/api'
import { getAllStorage3 } from 'network/api'
export default {
  data () {
    return {
      storgaeListData: []
    }
  },
  created () {
    getAllStorage3({ key: this.$configList[window.location.host] }).then((res) => {
      if (res.code === 1) {
        const storageData = res.data
        const arr = []
        // this.storgaeListData = this.storgaeListData.map(item => {...item, name: item.name.split('-')[0].replace('【', '').replace('】', '')})
        storageData.forEach(item => {
          item.name = item.name.split('-')[0].replace('【', '').replace('】', '')
          if (arr.indexOf(item.name) === -1) {
            arr.push(item.name)
            this.storgaeListData.push(item)
          }
        })
      }
    })
  },
  methods: {
    to () {
      this.$router.push('/orderAdmin/purchase')
    }
  }
}
</script>
<style scoped>
  .ckWrap{
    width: 100%;
    display: flex;
    justify-content: center;
    background: #efefef;
    padding: 20px;
  }
  .ckTitles{
    margin-left: 20px;
    font-weight: 500;
    color: #333;
  }
  .menuLeftck{
    width: 1200px;
    height: auto;
    padding: 20px;
    background: #fff;
    border-radius: 15px;
  }
  .menuLeftWrapck{
    width: 100%;
    box-sizing: border-box;
    padding: 0 18px 40px;
  }
  .storeNameck{
    float: left;
    width: 220px;
    height: 50px;
    padding: 0 10px;
    margin: 20px 6px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    font-size: 15px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAAAyCAYAAAA3FLVzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAn1JREFUeNrsmz+v0lAYh0/vgAOWP2G8n8DERHRxJBAWogMdvXGm+gWYu/MBtLsJK8OlE1snFyPmJn6CO5ehJaH8831N2HQptibt8yRvTunWN+fhVw7nWOfz2Siu69Zk+CD1Tuq51FMDAFmJpR6k5lKffd9P9aalwolst3J9nyRJdzwem36/bzqdDi2DXDgcDma73Zb6GaMoMmEYmiAIjG3b3+XWW5Hu0ZpMJppsXxuNRnc2mzEbIHdUNpWuKnieZyTM1nL5+kbfJuM4RjYohOPxWCnZLsKJYy/kcqLC3TmOw0yAQkjTtJLPPRqNdLhT4V4Nh0NmAuTO6XQy+/2+ks/e6/V0eKnC1VqtFrMBSLccaTabOjy5YRpAEehqeJWFu4BwQLohHJBuCAeQCV0ouexoQjiAnNntdjQB4YB0Qzgg3RAOIGu66Z/dgHBQAKxMIhwUhG5Q1o3KgHBAuiEclIcqHsFBOCDdEA7KTpWP4CAckG4IB2WFTcoIB6QbwgHphnAAV8AmZYSDAmGTMsJBgb/dSDeEgwKFA4SDgn67cQQH4YB0QzgoFxzBQTgg3RAOygdHcBAOSDeEg/LBERyEA9IN4aB8sEkZ4YB0Qzgg3QDh4Mp0Y5MywgGvkwgHpBsgHJBu/124dLPZ0An4KxzBuZ4oinSIVbhvq9WKjgDpliNhGOrwoMLNF4sFHYE/whGcf0MQBDrMVTi/Xq+vp9MpXQHSLQc8zzO2bf9Q1yxdeXJd91Y+3CdJ0nUcxwwGA9Nut+lUxdFkkzlBIzKg6yL6GrlcLlW2tdx64/v+o3VZ6hXpajJ8lHov9UyqTtsAMqPfVD+lvkh9Etl+vyr8EmAArFZPMC5CPY0AAAAASUVORK5CYII=) no-repeat 100%/100%
  }
  .storeNameck:hover {
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAAAyCAYAAAA3FLVzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA15JREFUeNrs3M1LVFEcxvGfSho5A1pBC0EoEqopshbZsoUSUbQtRVqabapN0Ka/okW5L0dzRDNDhzSzMrQXX0qpNIUszd5Umpk773M7Z2hXbpzuWXi/HzjecXb34T6cuc79mWfbtmjzvqpCdWhUq1at/Wp5BMB6hdWaVMuv1s3yqZGEfjNPF06VrUy97h7wFFVW1J8RX021eLdvIzI4Ij7+Rr5furqhz9HKpGUuHpOlVFKqvSXj6q1TqnQLeR/3HdE728jonl2Vp5uuczXAcT+uXJPY81HXnO+wFZKjW7wT6mVVvvpxfsBTSNlgRHJmVmIvxlx1zqps0h9ePaheNujC1VXUn+VKgBEhf0Dkz98N3GRHwSZ9qNOFO+w7cZwrAY5LLX4R69GQK899Z9FmfTikC1foLSnhaoDjwi0dIum0K8+9OL9AH4ryuQxgQnplVSK9D1yfA4WDmd0t0CV2PEHhuBTgNNuKSqSzmyAoHIzsbl09kglHCILCwfHdLZmS8J0OgqBwMMEK9kv65zJBUDg4LmNLqKWdHCgcTIg+eSapTwsEQeFgQqg5QAgUDibERyck8W6aICgcjOxufnY3CgcjsiM4Lpp3o3Dg3o3CwQ1SC4tiDQ4RBIWDkd2t1b0jOBQORqWXV8Tq7SMICgcTwu2M4FA4GJGJWBLpvE8QFA4mRBjBoXAwIzuC09ZJEBQOJljBPkZwKBzM3LzZEvIzgkPhYET08ZCkPi8SBIWDCTzGReFgSPzVuCTezxAEhQO7G4XDBpKcnpXYyzGCoHAw4VdzGyFQOJigR3Cig08JgsLByL2b/t4tYxMEhYPT9BMlVvAhQVA4mBAO3BU7wQgOhYPj9DSAngoAhYMBjOBQOBiiP0bqj5OgcDBA/6GEERwKByM3b4zg/M/CJUKrqySBNekvufWX3cjhE0Im+68Dw7pwo1M9QRLBmniMK3dz8Zg+TOrC+T/cbiUR/JN+QFk/qIzcLKWS+uDXhWs6FopP3Gu8SCr4CyM4uRu2QlLtLXmtu5Zn27bM+6rK1C/dA56iyt3nauVATbV4tpaSlMvp4dJvDZcJYl33bBmZjUflayqhylY6od46WT41spAtnKZKV6gOF9SqV2uvWsXEBqybfkLgrVq31LqhypZ9Hu63AAMAwchLsQC+llUAAAAASUVORK5CYII=) no-repeat 100%/100%
  }
  .storeNameck:hover .price{
    color: #fff;
  }
  .price{
    color: #e12a36;
    font-weight: 600;
    font-size: 16px;
  }
  .subtitle {
    position: absolute;
    background: url(data:image/png;base64,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) no-repeat 100%/100%;
    width: 90px;
    height: 40px;
    top: -26px;
    left: 130px;
    line-height: 30px;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 1px
  }
</style>
